/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BigqueryAuthorizeOauthAuthorizeBigqueryGetParams,
  BigqueryCallbackOauthCallbackBigqueryGetParams,
  GoogleWorkspaceAuthorizeOauthAuthorizeGoogleGetParams,
  GoogleWorkspaceAuthorizeResponse,
  GranolaCallbackOauthCallbackGranolaGetParams,
  HTTPValidationError,
  HubspotCallbackOauthCallbackHubspotGetParams
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * Return the HubSpot OAuth authorize URL for the current user.
 * @summary Initiate HubSpot OAuth flow
 */
export const hubspotAuthorizeOauthAuthorizeHubspotGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/oauth/authorize/hubspot`, method: 'GET', signal
    },
      );
    }
  



export const getHubspotAuthorizeOauthAuthorizeHubspotGetQueryKey = () => {
    return [
    `/oauth/authorize/hubspot`
    ] as const;
    }

    
export const getHubspotAuthorizeOauthAuthorizeHubspotGetQueryOptions = <TData = Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHubspotAuthorizeOauthAuthorizeHubspotGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>> = ({ signal }) => hubspotAuthorizeOauthAuthorizeHubspotGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HubspotAuthorizeOauthAuthorizeHubspotGetQueryResult = NonNullable<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>>
export type HubspotAuthorizeOauthAuthorizeHubspotGetQueryError = unknown


export function useHubspotAuthorizeOauthAuthorizeHubspotGet<TData = Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>,
          TError,
          Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHubspotAuthorizeOauthAuthorizeHubspotGet<TData = Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>,
          TError,
          Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHubspotAuthorizeOauthAuthorizeHubspotGet<TData = Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Initiate HubSpot OAuth flow
 */

export function useHubspotAuthorizeOauthAuthorizeHubspotGet<TData = Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotAuthorizeOauthAuthorizeHubspotGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHubspotAuthorizeOauthAuthorizeHubspotGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Return the Granola OAuth authorize URL for the current user.

Uses Dynamic Client Registration (DCR) + PKCE (S256) as required
by Granola's MCP OAuth server.
 * @summary Initiate Granola OAuth flow
 */
export const granolaAuthorizeOauthAuthorizeGranolaGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/oauth/authorize/granola`, method: 'GET', signal
    },
      );
    }
  



export const getGranolaAuthorizeOauthAuthorizeGranolaGetQueryKey = () => {
    return [
    `/oauth/authorize/granola`
    ] as const;
    }

    
export const getGranolaAuthorizeOauthAuthorizeGranolaGetQueryOptions = <TData = Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGranolaAuthorizeOauthAuthorizeGranolaGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>> = ({ signal }) => granolaAuthorizeOauthAuthorizeGranolaGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GranolaAuthorizeOauthAuthorizeGranolaGetQueryResult = NonNullable<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>>
export type GranolaAuthorizeOauthAuthorizeGranolaGetQueryError = unknown


export function useGranolaAuthorizeOauthAuthorizeGranolaGet<TData = Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>,
          TError,
          Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGranolaAuthorizeOauthAuthorizeGranolaGet<TData = Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>,
          TError,
          Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGranolaAuthorizeOauthAuthorizeGranolaGet<TData = Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Initiate Granola OAuth flow
 */

export function useGranolaAuthorizeOauthAuthorizeGranolaGet<TData = Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaAuthorizeOauthAuthorizeGranolaGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGranolaAuthorizeOauthAuthorizeGranolaGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Return the BigQuery OAuth authorize URL for the current user.
 * @summary Initiate BigQuery OAuth flow
 */
export const bigqueryAuthorizeOauthAuthorizeBigqueryGet = (
    params?: BigqueryAuthorizeOauthAuthorizeBigqueryGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/oauth/authorize/bigquery`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getBigqueryAuthorizeOauthAuthorizeBigqueryGetQueryKey = (params?: BigqueryAuthorizeOauthAuthorizeBigqueryGetParams,) => {
    return [
    `/oauth/authorize/bigquery`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBigqueryAuthorizeOauthAuthorizeBigqueryGetQueryOptions = <TData = Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError = HTTPValidationError>(params?: BigqueryAuthorizeOauthAuthorizeBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBigqueryAuthorizeOauthAuthorizeBigqueryGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>> = ({ signal }) => bigqueryAuthorizeOauthAuthorizeBigqueryGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BigqueryAuthorizeOauthAuthorizeBigqueryGetQueryResult = NonNullable<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>>
export type BigqueryAuthorizeOauthAuthorizeBigqueryGetQueryError = HTTPValidationError


export function useBigqueryAuthorizeOauthAuthorizeBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError = HTTPValidationError>(
 params: undefined |  BigqueryAuthorizeOauthAuthorizeBigqueryGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>,
          TError,
          Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBigqueryAuthorizeOauthAuthorizeBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError = HTTPValidationError>(
 params?: BigqueryAuthorizeOauthAuthorizeBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>,
          TError,
          Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBigqueryAuthorizeOauthAuthorizeBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError = HTTPValidationError>(
 params?: BigqueryAuthorizeOauthAuthorizeBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Initiate BigQuery OAuth flow
 */

export function useBigqueryAuthorizeOauthAuthorizeBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError = HTTPValidationError>(
 params?: BigqueryAuthorizeOauthAuthorizeBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryAuthorizeOauthAuthorizeBigqueryGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBigqueryAuthorizeOauthAuthorizeBigqueryGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Authorize a configured Drive, Sheets, or Gmail connector.
 * @summary Initiate Google Workspace connector OAuth flow
 */
export const googleWorkspaceAuthorizeOauthAuthorizeGoogleGet = (
  params: GoogleWorkspaceAuthorizeOauthAuthorizeGoogleGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GoogleWorkspaceAuthorizeResponse>(
    { url: `/oauth/authorize/google`, method: 'GET', params, signal },
  );
};



/**
 * Exchange the authorization code for access + refresh tokens, encrypt
them, and store in connector_configurations.
 * @summary HubSpot OAuth callback (code exchange)
 */
export const hubspotCallbackOauthCallbackHubspotGet = (
    params: HubspotCallbackOauthCallbackHubspotGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/oauth/callback/hubspot`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getHubspotCallbackOauthCallbackHubspotGetQueryKey = (params?: HubspotCallbackOauthCallbackHubspotGetParams,) => {
    return [
    `/oauth/callback/hubspot`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getHubspotCallbackOauthCallbackHubspotGetQueryOptions = <TData = Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError = HTTPValidationError>(params: HubspotCallbackOauthCallbackHubspotGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHubspotCallbackOauthCallbackHubspotGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>> = ({ signal }) => hubspotCallbackOauthCallbackHubspotGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HubspotCallbackOauthCallbackHubspotGetQueryResult = NonNullable<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>>
export type HubspotCallbackOauthCallbackHubspotGetQueryError = HTTPValidationError


export function useHubspotCallbackOauthCallbackHubspotGet<TData = Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError = HTTPValidationError>(
 params: HubspotCallbackOauthCallbackHubspotGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>,
          TError,
          Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHubspotCallbackOauthCallbackHubspotGet<TData = Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError = HTTPValidationError>(
 params: HubspotCallbackOauthCallbackHubspotGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>,
          TError,
          Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHubspotCallbackOauthCallbackHubspotGet<TData = Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError = HTTPValidationError>(
 params: HubspotCallbackOauthCallbackHubspotGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary HubSpot OAuth callback (code exchange)
 */

export function useHubspotCallbackOauthCallbackHubspotGet<TData = Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError = HTTPValidationError>(
 params: HubspotCallbackOauthCallbackHubspotGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hubspotCallbackOauthCallbackHubspotGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHubspotCallbackOauthCallbackHubspotGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Exchange the Granola authorization code for tokens and persist them.
 * @summary Granola OAuth callback (code exchange)
 */
export const granolaCallbackOauthCallbackGranolaGet = (
    params: GranolaCallbackOauthCallbackGranolaGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/oauth/callback/granola`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGranolaCallbackOauthCallbackGranolaGetQueryKey = (params?: GranolaCallbackOauthCallbackGranolaGetParams,) => {
    return [
    `/oauth/callback/granola`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGranolaCallbackOauthCallbackGranolaGetQueryOptions = <TData = Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError = HTTPValidationError>(params: GranolaCallbackOauthCallbackGranolaGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGranolaCallbackOauthCallbackGranolaGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>> = ({ signal }) => granolaCallbackOauthCallbackGranolaGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GranolaCallbackOauthCallbackGranolaGetQueryResult = NonNullable<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>>
export type GranolaCallbackOauthCallbackGranolaGetQueryError = HTTPValidationError


export function useGranolaCallbackOauthCallbackGranolaGet<TData = Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError = HTTPValidationError>(
 params: GranolaCallbackOauthCallbackGranolaGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>,
          TError,
          Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGranolaCallbackOauthCallbackGranolaGet<TData = Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError = HTTPValidationError>(
 params: GranolaCallbackOauthCallbackGranolaGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>,
          TError,
          Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGranolaCallbackOauthCallbackGranolaGet<TData = Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError = HTTPValidationError>(
 params: GranolaCallbackOauthCallbackGranolaGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Granola OAuth callback (code exchange)
 */

export function useGranolaCallbackOauthCallbackGranolaGet<TData = Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError = HTTPValidationError>(
 params: GranolaCallbackOauthCallbackGranolaGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof granolaCallbackOauthCallbackGranolaGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGranolaCallbackOauthCallbackGranolaGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Exchange the BigQuery authorization code for tokens and persist them.
 * @summary BigQuery OAuth callback (code exchange)
 */
export const bigqueryCallbackOauthCallbackBigqueryGet = (
    params: BigqueryCallbackOauthCallbackBigqueryGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/oauth/callback/bigquery`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getBigqueryCallbackOauthCallbackBigqueryGetQueryKey = (params?: BigqueryCallbackOauthCallbackBigqueryGetParams,) => {
    return [
    `/oauth/callback/bigquery`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBigqueryCallbackOauthCallbackBigqueryGetQueryOptions = <TData = Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError = HTTPValidationError>(params: BigqueryCallbackOauthCallbackBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBigqueryCallbackOauthCallbackBigqueryGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>> = ({ signal }) => bigqueryCallbackOauthCallbackBigqueryGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BigqueryCallbackOauthCallbackBigqueryGetQueryResult = NonNullable<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>>
export type BigqueryCallbackOauthCallbackBigqueryGetQueryError = HTTPValidationError


export function useBigqueryCallbackOauthCallbackBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError = HTTPValidationError>(
 params: BigqueryCallbackOauthCallbackBigqueryGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>,
          TError,
          Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBigqueryCallbackOauthCallbackBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError = HTTPValidationError>(
 params: BigqueryCallbackOauthCallbackBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>,
          TError,
          Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBigqueryCallbackOauthCallbackBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError = HTTPValidationError>(
 params: BigqueryCallbackOauthCallbackBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary BigQuery OAuth callback (code exchange)
 */

export function useBigqueryCallbackOauthCallbackBigqueryGet<TData = Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError = HTTPValidationError>(
 params: BigqueryCallbackOauthCallbackBigqueryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bigqueryCallbackOauthCallbackBigqueryGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBigqueryCallbackOauthCallbackBigqueryGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}


